import request from '@/utils/request'

let Route_categoryApi = {

  /*路线类目列表*/
  list(data) {
    return request._post('/shop/plus.route_category.Index/index', data);
},
/*路线类目分类列表(树形)*/
catList(data) {
    return request._post('/shop/plus.route_category.Index/catList', data);
},
/*添加路线类目*/
add(data) {
    return request._post('/shop/plus.route_category.Index/add', data);
},
/*修改路线类目*/
edit(data) {
    return request._post('/shop/plus.route_category.Index/edit', data);
},
/*删除路线类目*/
del(data) {
    return request._post('/shop/plus.route_category.Index/del', data);
},
saveProvinceImages(data) {
    return request._post('/shop/plus.route_category.Index/saveProvinceImages', data);
},
renameProvince(data) {
    return request._post('/shop/plus.route_category.Index/renameProvince', data);
},

/*路线类目详情*/
detail(data) {
  return request._post('/shop/plus.route_category.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.route_category.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.route_category.Setting/getSetting', data, errorback);
    },
}
export default Route_categoryApi;



// WEBPACK FOOTER //
// ./src/api/route_category.js